export const tool = "ai-clothes-changer";

export const frameCostPerClothChange = 25;
